export default __webpack_public_path__ + "static/FiraMono-Medium-29e7c3077b6056c8c84499e7cdfacd96.woff";